import { styled } from '@mui/material';
import { LANGUAGE_OPTIONS } from 'locales/constants';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Button, Form, Icon, Stack, Text, TextInput, Tooltip } from 'shell/components';

const MobileCourseDetails = ({
    loading,
    form,
    isDirty,
    errors,
    onChange,
    onSubmit,
    setSelected,
    handleSettingDropDown,
}) => {
    const { t } = useTranslation();

    return (
        <Stack spacing={4}>
            <Stack alignItems={'flex-start'} spacing={2}>
                <Button
                    aria-label={'back'}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    size={'medium'}
                    variant={'tertiary'}
                    onClick={() => setSelected('')}
                >
                    {t('controls.back', 'Back')}
                </Button>
                <Stack alignItems={'center'} direction={'row'} spacing={4}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('course-settings.course-details.title', 'Course Details')}
                    </Text>
                    {/* <Dropdown
                        id={'course-setting-dropdown'}
                        options={[{ key: 'delete', value: 'Delete Course' }]}
                        rootComponent={
                            <IconButton
                                aria-label={'more options'}
                                kind={'moreHorizontal'}
                                size={'medium'}
                                variant={'square'}
                            />
                        }
                        onSelect={handleSettingDropDown}
                    /> */}
                </Stack>
            </Stack>
            <CustomForm onSubmit={onSubmit}>
                <TextInput
                    error={Boolean(errors.name)}
                    helperText={errors.name}
                    label={t('course-settings.course-details.course-name-label', 'Course Name')}
                    required
                    value={form.name}
                    onChange={(e) => onChange('name', e.target.value)}
                />
                <Autocomplete
                    disableClearable
                    label={
                        <Stack alignItems={'center'} direction={'row'} spacing={2}>
                            <Text>
                                {t('course-settings.course-details.feedback-language-label', 'Feedback Language')}
                            </Text>{' '}
                            <Tooltip
                                content={t(
                                    'course-settings.course-details.feedback-language-tooltip',
                                    'Choose the language you want assignment feedback to be delivered in. If you change this setting midway through a course, any new feedback generated from that point on will use the updated language.'
                                )}
                                type={'info'}
                            />
                        </Stack>
                    }
                    options={LANGUAGE_OPTIONS}
                    placeholder={t('ui.select', 'Select')}
                    value={form?.language}
                    onChange={(_, value) => onChange('language', value)}
                />

                <ButtonStack spacing={2}>
                    <CustomButton disabled={!isDirty} loading={loading} type={'submit'}>
                        {t('controls.save', 'Save')}
                    </CustomButton>
                </ButtonStack>
            </CustomForm>
        </Stack>
    );
};

const ButtonStack = styled(Stack)(({ theme }) => {
    return {
        marginTop: theme.spacing(7),
        width: '100%',
        alignSelf: 'flex-end',
    };
});

const CustomButton = styled(Button)(() => {
    return {
        width: '100%',
    };
});

const CustomForm = styled(Form)(({ theme }) => {
    return {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridGap: theme.spacing(4),
    };
});

export default MobileCourseDetails;
